import React from 'react';

interface ExpanderProps {
  isExpanded: boolean;
  children: React.ReactNode;
}

const Expander: React.FC<ExpanderProps> = ({ isExpanded, children }) => {
  const overflow = isExpanded ? 'visible' : 'hidden';
  return (
    <div
      style={{
        maxHeight: isExpanded ? '150px' : '0px',
        transition: 'max-height 0.3s ease-in-out, overflow 0.3s ease-in-out',
        overflow
      }}
    >
      {children}
    </div>
  );
};

export default Expander;
